import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';

import { AuthService } from '../../services/auth.service';

import { SweetAlertService } from './../../../shared/services/sweet-alert/sweet-alert.service';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent implements OnInit {
  cardTitle: string = 'Acesso ao Sistema';

  // Form definitions.
  form: FormGroup;
  @ViewChild('email') emailFocus: ElementRef;
  @ViewChild('password') passwordFocus: ElementRef;

  // Form submission control.
  submitted: boolean = false;
  showPassword: boolean = false;

  // Control of loading of the service.
  segmentDimmed: boolean = true;

  constructor(
    private title: Title,
    private fb: FormBuilder,
    private authService: AuthService,
    private sweetAlertService: SweetAlertService,
    private router: Router
  ) { }

  ngOnInit() {
    this.title.setTitle(`SIVEL Check | ${ this.cardTitle }`);
    this.createForm();

    this.segmentDimmed = false;
  }

  get email() {
    return this.form.get('email');
  }

  get password() {
    return this.form.get('password');
  }

  onSubmit() {
    // Disable submit to avoid multiple requests.
    this.submitted = true;
    this.segmentDimmed = true;

    return this.authService.signIn(this.email.value, this.password.value)
      .then(user => {
        if (this.form.valid) {
          this.submitted = false;
          this.segmentDimmed = false;
        }
      })
      .catch(error => {
        this.submitted = false;
        this.segmentDimmed = false;

        console.log(error);

        this.sweetAlertService.error({ message: this.authService.errorMessage(error.code) }).then(() => {
          this.emailFocus.nativeElement.focus();
          this.emailFocus.nativeElement.select();
        });
      });
  }

  resetForm(fieldFocus?: HTMLElement) {
    this.form.reset();

    if (fieldFocus) {
      fieldFocus.focus();
    }
  }

  toggleShowPassword() {
    if (this.showPassword) {
      this.passwordFocus.nativeElement.type = 'password';
    } else {
      this.passwordFocus.nativeElement.type = 'text';
    }
    this.showPassword = !this.showPassword;
  }

  private createForm() {
    this.form = this.fb.group({
      email: ['', Validators.compose([Validators.required, Validators.email])],
      password: ['', Validators.compose([
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(25),
        Validators.pattern('^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$')
        // PasswordValidators.repeatCharacterRegexRule(3),
        // PasswordValidators.alphabeticalCharacterRule(1),
        // PasswordValidators.digitCharacterRule(1),
        // PasswordValidators.lowercaseCharacterRule(1),
        // PasswordValidators.uppercaseCharacterRule(1),
        // PasswordValidators.specialCharacterRule(1)
      ])]
    });
  }
}
